import styled from 'styled-components';

export const Button = styled.button`
  border: 0 none;
  background: none;
  margin-bottom: 15px;
  display: inline-flex;
  align-items: center;

  &:hover {
    opacity: 0.7;
  }

  svg {
    margin-right: 5px;
  }
`;
